import amapi from 'Api/amapi'

const initialState = () => ({
  spam_enabled: 0,
  spam_box_enabled: 0,
  spam_auto_delete: 0,
  spam_auto_delete_score: 0,
  spam_score: '',
  other: {}
})

const state = initialState

const getters = {
  spam_enabled: state => !!state.spam_enabled,
  spam_box_enabled: state => !!state.spam_box_enabled,
  spam_auto_delete: state => !!state.spam_auto_delete,
  spam_auto_delete_score: state => state.spam_auto_delete_score,
  spam_score: state => state.spam_score,
  spam_filters: state => state.other
}

const mutations = {
  SET_SPAM_STATUS: (state, status) => {
    state.spam_enabled = status
  },
  SET_SPAM_BOX_STATUS: (state, status) => {
    state.spam_box_enabled = status
  },
  SET_SPAM_AUTO_DELETE: (state, status) => {
    state.spam_auto_delete = status
  },
  SET_SPAM_SCORE: (state, value) => {
    state.spam_score = value
  },
  SET_AUTO_DELETE_SCORE: (state, value) => {
    state.spam_auto_delete_score = value
  },

  SET_SPAM_FILTER: (state, payload) => {
    state.spam_enabled = payload.spam_enabled

    state.other = payload
  },

  CLEAR_SPAM_FILTERS_STORE (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

const actions = {
  async getSpamSettings ({ commit }, _username) {
    const data = {
      uapi_module: 'Email',
      uapi_function: 'get_spam_settings',
      _username,
    }

    try {
      const response = await amapi.cpanel_uapi(data)

      commit('SET_SPAM_STATUS', response.data.spam_enabled)
      commit('SET_SPAM_BOX_STATUS', response.data.spam_box_enabled)
      commit('SET_SPAM_AUTO_DELETE', response.data.spam_auto_delete)
      commit('SET_AUTO_DELETE_SCORE', response.data.spam_auto_delete_score)
      commit('SET_SPAM_FILTER', response.data)
    } catch (e) {
      throw e
    }
  },
  async enableSpamAssassin ({ dispatch }) {
    const data = {
      uapi_module: 'Email',
      uapi_function: 'enable_spam_assassin'
    }

    try {
      await amapi.cpanel_uapi({ ...data })
      await dispatch('getSpamSettings')

      return 'Apache SpamAssassin has been enabled.'
    } catch (e) {
      throw e
    }
  },
  async disableSpamAssassin ({ getters, dispatch }, _username) {
    const data = {
      uapi_module: 'Email',
      uapi_function: 'disable_spam_assassin',
      _username,
    }

    try {
      await amapi.cpanel_uapi({ ...data })
      await dispatch('getSpamSettings')

      return 'Apache SpamAssassin has been disabled.'
    } catch (e) {
      throw e
    }
  },
  async enableSpamBox ({ dispatch }, _username) {
    const data = {
      uapi_module: 'Email',
      uapi_function: 'enable_spam_box',
      _username,
    }

    try {
      await amapi.cpanel_uapi({ ...data })
      await dispatch('getSpamSettings')

      return 'Spam Box has been enabled.'
    } catch (e) {
      throw e
    }
  },
  async disableSpamBox ({ dispatch }, _username) {
    const data = {
      uapi_module: 'Email',
      uapi_function: 'disable_spam_box',
      _username,
    }

    try {
      await amapi.cpanel_uapi({ ...data })
      await dispatch('getSpamSettings')

      return 'Spam Box has been disabled.'
    } catch (e) {
      throw e
    }
  },
  async addSpamFilter ({ dispatch, getters }, { score = '', _username }) {
    const data = {
      uapi_module: 'Email',
      uapi_function: 'add_spam_filter',
      _username,
      required_score: score === '' ? getters.spam_auto_delete_score : score
    }

    try {
      await amapi.cpanel_uapi(data)
      await dispatch('getSpamSettings', _username)

      return 'Spam Auto-Delete has been enabled.'
    } catch (e) {
      throw e
    }
  },
  async disableSpamAutoDelete ({ dispatch }, _username) {
    const data = {
      uapi_module: 'Email',
      uapi_function: 'disable_spam_autodelete',
      _username,
    }

    try {
      await amapi.cpanel_uapi({ ...data })
      await dispatch('getSpamSettings', _username)

      return 'Spam Auto-Delete has been disabled.'
    } catch (e) {
      throw e
    }
  },
  async getUserPreferences ({ commit, dispatch }, _username) {
    const data = {
      uapi_module: 'SpamAssassin',
      uapi_function: 'get_user_preferences',
      _username,
    }

    try {
      const r = await amapi.cpanel_uapi({ ...data })

      const score = (r?.data?.required_score === undefined) ? '5' : r.data.required_score[0]
      commit('SET_SPAM_SCORE', score)

      if (r?.data?.required_score === undefined) {
        dispatch('updateUserPreferences')
      }
    } catch (e) {
      throw e
    }
  },
  async updateUserPreferences ({ commit, getters }, { score = '', _username } = {}) {
    const data = {
      uapi_module: 'SpamAssassin',
      uapi_function: 'update_user_preference',
      _username,
      preference: 'required_score',
      value: score === '' ? getters.spam_score : score
    }

    try {
      const r = await amapi.cpanel_uapi(data)
      commit('SET_SPAM_SCORE', r.data.required_score[0])
    } catch (e) {
      throw e
    }
  },
  async emptySpamBox ({ commit }, _username) {
    const data = {
      uapi_module: 'SpamAssassin',
      uapi_function: 'clear_spam_box',
      _username,
    }

    try {
      await amapi.cpanel_uapi({ ...data })

      return 'All Spam Box folders expunged.'
    } catch (e) {
      throw e
    }
  },
}
const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
